import React from "react";
import { StyledPagination } from './pagination.style';
import { useTheme } from "styled-components";
import DefaultUptimeTheme from "component/theme/defaultTheme";
import { handleKeyPress } from "utils/functions";
export interface IPaginationProps {
  width?: string,
  count?: number,
  onChange?:()=>{},
  page?: number
  className?: string;
  disabled?: boolean;
  isUnderKnowledgePage: boolean;
}
const Pagination = ({width,count,onChange,page,className,disabled, isUnderKnowledgePage = false, ...props }: IPaginationProps) => {
  const theme = useTheme() as typeof DefaultUptimeTheme;
  return (
    <StyledPagination

      count={count}
      shape="rounded"
      onChange={onChange}
      page={page}
      className={className}
      disabled={disabled}
      sx={{".MuiPaginationItem-page.Mui-selected": {
        backgroundColor: `${isUnderKnowledgePage ? theme.uptimeColors.mainTheme.primary : theme.uptimeColors.grayScales.white}`,
        border: `1px solid ${theme.uptimeColors.mainTheme.primary}`,
        color: `${isUnderKnowledgePage ? theme.uptimeColors.grayScales.white : 'unset'}`,
      }}}
      onKeyDown={(e: any) => handleKeyPress(e, 'Enter', onChange)}
      {...props}
    />
  );
};

export default Pagination;